import { emit } from './emit'

/** Segment events instrumenting new-storefront funnel moments: search arrival, the
 *  "Request medication" CTA, the visit-type booking screen, and provider-page arrival.
 *  PDP/pharmacy/homepage arrival events belong in sessionReplayPageViewedAnalytics.ts, not here. */

export const NewStorefrontEvents = {
    SEARCH_VIEWED: 'new_storefront_search_viewed',
    REQUEST_MEDICATION_CLICKED: 'new_storefront_request_medication_clicked',
    VISIT_TYPE_SCREEN_VIEWED: 'new_storefront_visit_type_screen_viewed',
    BOOK_CHAT_VISIT_CLICKED: 'new_storefront_book_chat_visit_clicked',
    BOOK_VIDEO_VISIT_CLICKED: 'new_storefront_book_video_visit_clicked',
    PROVIDER_PAGE_VIEWED: 'new_storefront_provider_page_viewed',
} as const

export type NewStorefrontEvent = (typeof NewStorefrontEvents)[keyof typeof NewStorefrontEvents]

export function trackNewStorefrontEvent(event: NewStorefrontEvent, properties: Record<string, unknown> = {}): void {
    emit(event, properties)
}
